import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Sappptemplate extends Component {
 
  render() {
    const course =[
      {
        title : " Introduction to SAP PP",
        content: [
        "Overview of SAP PP and its role in the SAP ecosystem",
        "Introduction to Production Planning processes and functionalities",
        "SAP PP integration with other SAP modules"
        ]
        },
        {
        title : " Master Data in Production Planning",
        content: [
        "Configuration and Use of Material Master in SAP PP",
        "Bill of Material (BOM) Configuration and Usage",
        "Routings (Task Lists) Configuration and Application in Production Planning",
        "Work Center Configuration and Utilization in Production Planning"
        ]
        },
        {
        title : " Sales and Operations Planning (S&OP)",
        content: [
        "Overview of Sales and Operations Planning",
        "Demand Management Planning Strategies and Planned Independent Requirements",
        "Long-Term Planning in SAP PP"
        ]
        },
        {
        title : " Material Requirement Planning (MRP)",
        content: [
        "Master Production Scheduling Procedure",
        "Consumption-Based Planning (Re-order Point Planning, Forecast-Based, and Time-Phased)",
        "Material Requirement Planning Run Configuration and Execution",
        "Material Requirement Planning Evaluation Tools"
        ]
        },
        {
        title : " Capacity Planning",
        content: [
        "Capacity Planning Master Data Components",
        "Capacity Planning Scheduling Parameters",
        "Available Capacity Determination in SAP PP",
        "Capacity Evaluation and Analysis"
        ]
        },
        {
        title : " Production Orders",
        content: [
        "Scheduling of Production Orders in SAP PP",
        "Production Order Components and Structure",
        "Utilizing Production Resources & Tools (PRTs) in Production Orders"
        ]
        },
        {
        title : " Discrete Manufacturing",
        content: [
        "Understanding the Planned Order Structure",
        "Different Types of Production Orders in Discrete Manufacturing",
        "Material Staging and Withdrawal Processes",
        "Production Confirmation and Goods Movements",
        "Order Settlement in SAP PP"
        ]
        },
        {
        title : " Repetitive Manufacturing",
        content: [
        "Master Data in Repetitive Manufacturing",
        "Planning Processes in Repetitive Manufacturing",
        "Using the Planning Table in Repetitive Manufacturing",
        "Material Staging using Pull List",
        "Backflushing in Repetitive Manufacturing"
        ]
        },
        {
        title : " Reporting and Analysis in SAP PP",
        content: [
        "Production Planning Reporting and Analysis",
        "Material Requirement Planning Reporting and Analysis",
        "Utilizing Mass Change Functions for Master Data Maintenance"
        ]
        },
        {
        title : " Integration with Other SAP Modules",
        content: [
        "Integration of SAP PP with other SAP modules like MM, SD, QM, etc."
        ]
        },
        
    ]

 
    const faqData = [
      {
        question: 'What is SAP PP?',
        answer:
          'SAP PP (Production Planning) is a core module of the SAP ERP system that handles all aspects of production planning, execution, and control within a manufacturing organization. It streamlines the entire production process, from material requirements planning to shop floor control and capacity planning',
      },
      {
        question: 'What career opportunities are available after the SAP PP course?',
        answer:
          'After completing our SAP PP course, you\'ll be qualified for roles such as SAP PP Consultant, Production Planning Analyst, Manufacturing Execution Specialist, and more. SAP PP skills are in high demand across various manufacturing industries and organizations',
      },
      {
        question: 'Will I learn to work with different SAP PP processes and functionalities?',
        answer:
        "Yes, our SAP PP course covers various processes and functionalities within the SAP PP module, including material requirements planning (MRP), capacity planning, shop floor control, production order management, and more. You'll gain exposure to different manufacturing scenarios and learn to customize and integrate SAP PP with other SAP modules",
      },
      {
        question: 'What types of companies hire SAP PP professionals?',
        answer:
          'SAP PP professionals are highly sought after by manufacturing companies, automotive firms, consumer goods companies, consulting firms, and enterprises across sectors such as aerospace, electronics, pharmaceuticals, and more',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"To enroll in our comprehensive SAP PP (Production Planning) course and kickstart your SAP PP Training journey, no prior experience with SAP products or production planning processes is required. Our beginner-friendly SAP PP course is designed for learners from diverse backgrounds, including students, manufacturing professionals, or anyone interested in mastering this powerful production management module. Basic computer literacy skills, such as navigating software interfaces and using the internet, are recommended but not mandatory. Throughout the SAP PP course, you'll start from the fundamentals, gaining a solid understanding of production planning strategies, master data configuration, capacity planning, and integration with other SAP modules. With hands-on projects and real-world scenarios, this SAP PP Training equips you with the skills to optimize production processes, streamline material flow, and drive efficient resource utilization using the latest SAP PP functionalities"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Susheela",
          date:" Sep 15 ,2023",
          review:` SAP PP is vital for those seeking a career in supply chain management. As businesses increasingly rely on SAP systems to streamline their material management, certified SAP PP professionals are in high demand.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Harees",
          date:" Sep 17 ,2023",
          review:"SAP PP training with certification offers a structured approach to learning the ins and outs of materials management. It validates your expertise, making you a sought-after professional in the field."
      },
  ]
    
    return(
      <>
         
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the intricate tapestry of enterprise resource planning, precision in production planning is the cornerstone of operational efficiency. SAP PP, an abbreviation denoting SAP Production Planning, emerges as a pivotal module within the SAP ERP (Enterprise Resource Planning) system. Tailored to cater to production planning and manufacturing processes, SAP PP orchestrates these vital operations within organizations. As a linchpin in supply chain management, SAP PP empowers businesses to meticulously plan, schedule, and govern the production of goods. "/>
             */}
               <NewMainsec rating='4.4' students={"288"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="In the intricate tapestry of enterprise resource planning, precision in production planning is the cornerstone of operational efficiency. SAP PP, an abbreviation denoting SAP Production Planning, emerges as a pivotal module within the SAP ERP (Enterprise Resource Planning) system. Tailored to cater to production planning and manufacturing processes, SAP PP orchestrates these vital operations within organizations. As a linchpin in supply chain management, SAP PP empowers businesses to meticulously plan, schedule, and govern the production of goods. "/>           

            <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		        <Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`SAP Production Planning (PP) Training is a comprehensive course designed to provide participants with the knowledge and skills to effectively manage and optimize production planning processes using the SAP PP module. SAP PP is a vital component of the SAP ERP system, dedicated to planning and controlling the production activities of an organization. This training aims to equip learners with the expertise to configure, customize, and streamline the SAP PP module, ensuring efficient production scheduling, resource utilization, and material requirements planning.`} 
            title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our SAP PP course covers Production Planning (PP) module in SAP ERP. Topics include master data management, production planning and control, production orders, material requirements planning (MRP), capacity planning, and production analytics. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in SAP PP. By the end of the course, you will be able to implement SAP PP practices in your own projects."}/>
		      </section>
          <Batchtime title={this.props.title} fees="39,999" offer="34,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
 <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>
        <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou2="SAP BASIS" coupath2="sap-basis" cou='SAP FICO' coupath='sap-fico' cou9='SAP SD' coupath9='sap-sd' cou6='SAP MM' coupath6='sap-mm' cou10='SAP BI' coupath10='sap-bi'
          cou5='SAP MDG' coupath5='sap-mdg' cou3='SAP FIORI' coupath3='sap-fiori' cou7='SAP HR' coupath7='sap-hr'
          cou1='SAP SCM' coupath1='sap-scm' cou8='SAP ABAP' coupath8='sap-abap'  cou4='SAP S4 HANA' coupath4='sap-s4-hana' />

        
      </>
    );
  }
}
